import { Pipe, PipeTransform } from '@angular/core';

/**
 * Takes an array of objects, and filters the array into an object map of arrays.
 * The keys in this map are the value of property `key`. aka obj[key]
 */
@Pipe({
    name: 'groupBy',
    standalone: false
})
export class GroupByPipe implements PipeTransform {
    transform(items: any[], key: string): { [key: string]: any[] } {
        return items.reduce((groups, item) => {
            const groupKey = item[key];

            if (!groups[groupKey]) {
                groups[groupKey] = [];
            }

            groups[groupKey].push(item);

            return groups;
        }, {});
    }
}
